// Components
import HighlightCard from './HighlightCard/HighlightCard';
// Types
import { HighlightClip } from './types';
// Styles
import styles from './StreamHighlights.module.scss';

type StreamHighlightsProps = {
  clips: HighlightClip[];
  playingClipId?: string | null;
  onPlay: (clip: HighlightClip) => void;
  onShare?: (clip: HighlightClip) => void;
};

const StreamHighlights = ({
  clips,
  playingClipId = null,
  onPlay,
  onShare,
}: StreamHighlightsProps): JSX.Element | null => {
  if (clips.length === 0) {
    return null;
  }

  const countLabel = clips.length === 1 ? '1 Clip' : `${clips.length} Clips`;

  return (
    <section
      className={styles.root}
      aria-labelledby="stream-highlights-heading"
    >
      <header className={styles.header}>
        <div className={styles.headerText}>
          <h2 id="stream-highlights-heading" className={styles.title}>
            Highlights
          </h2>
          <p className={styles.subtitle}>Check out the latest action.</p>
        </div>
        <p className={styles.count}>{countLabel}</p>
      </header>

      <ol className={styles.grid}>
        {clips.map((clip) => (
          <li key={clip.id} className={styles.gridItem}>
            <HighlightCard
              clip={clip}
              isPlaying={clip.id === playingClipId}
              onPlay={onPlay}
              onShare={onShare}
            />
          </li>
        ))}
      </ol>
    </section>
  );
};

export default StreamHighlights;
